// Contenido de celda que respeta el alto fijo del renglón (DEC-47): cada línea trunca con `title`.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/** Lo que se pinta en una línea de celda sin dato. */
export const NO_CELL_VALUE = '—';

/** Una línea de texto de celda: corta con puntos suspensivos y el texto completo va al `title`. */
export function CellText({
    children,
    title,
    className,
}: {
    children: ReactNode;
    title?: string;
    className?: string;
}) {
    const fullText = title ?? (typeof children === 'string' ? children : undefined);
    return (
        <span className={cn('block truncate', className)} title={fullText}>
            {children}
        </span>
    );
}

/** Celda de dos renglones: el segundo se reserva siempre, con «—» si falta, para que toda fila mida igual. */
export function CellLines({
    primary,
    secondary,
    primaryTitle,
    secondaryTitle,
    primaryClassName,
    secondaryClassName,
}: {
    primary: ReactNode;
    secondary: ReactNode;
    primaryTitle?: string;
    secondaryTitle?: string;
    primaryClassName?: string;
    secondaryClassName?: string;
}) {
    const hasSecondary = secondary !== null && secondary !== undefined && secondary !== '';
    return (
        <>
            <CellText title={primaryTitle} className={primaryClassName}>
                {primary}
            </CellText>
            <CellText
                title={secondaryTitle}
                className={cn(
                    'text-[9.5px] leading-tight text-muted-foreground',
                    secondaryClassName,
                )}
            >
                {hasSecondary ? secondary : NO_CELL_VALUE}
            </CellText>
        </>
    );
}
